import { h } from 'preact';
import { useState } from 'preact/hooks';
import GiftTagIcon from 'utils/icon/gift-tag.svg';
import Image from '../utils/image';

const MultiGwpItem = ({
  product,
  handleAddToCart,
  multiGwpInCart,
  reachedMultiGwpLimit
}) => {

  const [isGwpAdded, setIsGwpAdded] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [addBtnText, setAddBtnText] = useState('ADD');

  const multiGwpFoundInCart = multiGwpInCart.find(lineItem => (
    lineItem.product_id === product.id
  ));

  if (multiGwpFoundInCart?.id) {
    setIsGwpAdded(true);
  }
  else {
    setIsGwpAdded(false);
  }

  if (reachedMultiGwpLimit) {
    setIsBtnDisabled(true);
  }
  else {
    setIsBtnDisabled(false);
  }

  let btnClasses = isBtnDisabled ? 'disabled:bg-grey-3 disabled:border-grey-3 disabled:text-white' : '';
  if (isBtnDisabled && !isGwpAdded) {
    btnClasses += ` hover:!bg-white hover:!text-black`;
  }

  const handleClick = (event) => {
    setAddBtnText('ADDED');
    const targetElement = event.target;
    targetElement.disabled = true;

    setTimeout(() => {
      setAddBtnText('ADD');
      targetElement.disabled = false;
    }, 500);

    const gwpQty = 1;
    handleAddToCart(event.target, gwpQty);
  }

  return (
    <article className={
      `flex flex-row-reverse justify-end mb-5 flex flex-wrap pt-4 pb-5 
      border-b border-grey-4 last-of-type:border-0 lg:pt-5 lg:pb-6`
    }>
      <span>
        <p className='text-headline-tag' role='heading'>{product.title}</p>
        <p className='text-body-light'>{product.subtitle}</p>
        <p className='mb-5 flex items-center'>
          <GiftTagIcon className='relative top-[1.5px]' />
          <span className='ml-1 text-body-3'>{product.multiGwpGiftMsg}</span>
        </p>
        <div className='flex justify-start items-center'>
          <button
            className={`button button--secondary h-[44px] ${btnClasses}`}
            data-variant-id={reachedMultiGwpLimit ? 'Limit Reached' : product.variantId}
            data-subtitle={product.subtitle}
            type='button'
            onClick={(event) => handleClick(event)}
            disabled={isBtnDisabled}
          >
            {addBtnText}
          </button>
        </div>
      </span>
      <div className='flex basis-[80px] max-w-[80px] lg:basis-[100px] lg:max-w-[100px] cursor-pointer'>
        <Image
          src={product.featuredImage}
          srcWidths={{ sm: 180 }}
          classes='image block object-contain w-[80px] h-[80px] lg:w-[100px] lg:h-[100px]'
        />
      </div>
    </article>
  )
}

export default MultiGwpItem;